export const BASEPATH = process.env.REACT_APP_API_ENDPOINT;
export const ORG_ID = 1;
export const FREQUENCY = [
  "daily",
  "weekly",
  "monthly",
  "yearly",
  "30Days",
  "7Days",
];
export const ACTIVEROWCOLOR = "rgb(196 220 255)";
export const LANGUAGES = [
  { language: "English", code: "en" },
  { language: "Española", code: "es" },
];
export const LEAD_USER_KEY = "leadUser";
export const SELECTED_ORG_ID_KEY = "selectedOrgId";
